// src/pages/controleBar/mesas/MesaControlePage.js
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import './MesaControlePage.css';
import PageContainer from '../../../components/geral/PageContainer';
import PageHeader from '../../../components/geral/PageHeader';
import PageContent from '../../../components/geral/PageContent';
import { useNavigate, useParams } from 'react-router-dom';
import { FaPlus, FaPrint, FaDoorClosed, FaClipboardList, FaUtensils, FaTag, FaEdit } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa';
import { useComanda } from '../../../contexts/controleBar/comandas/ComandaContext';
import { useMesa } from '../../../contexts/controleBar/mesas/MesaContext';
import { useComandaItem } from '../../../contexts/controleBar/comandas/ComandaItemContext';
import CadComanda from '../comandas/CadComanda';
import { BsUnion } from 'react-icons/bs';
import { MdTableBar } from 'react-icons/md';
import JuntarComandasModal from '../comandas/JuntarComandasModal';
import ComandaItemModal from '../comandas/ComandaItemModal';
import { useProduto } from '../../../contexts/produtos/ProdutoContext';
import { useMessage } from '../../../contexts/geral/MessageContext';
import CadPedido from '../../pedidos/CadPedido';
import AddItemPedidoModal from '../../pedidos/AddItemPedidoModal';
import { usePedido } from '../../../contexts/pedidos/PedidoContext';
import { Pedido } from '../../../models/pedidos/Pedido';
import { getStatusComandaItemDescricao } from '../../../models/controleBar/comandas/StatusComandaItem';
import FecharComandaModal from '../comandas/FecharComandaModal';
import ImprimirResumoModal from '../comandas/ImprimirResumoModal';
import { usePrinterComanda } from '../../../contexts/geral/PrinterComandaContext';
import FecharMesaModal from './FecharMesaModal';
import { useAlert } from '../../../contexts/geral/AlertContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalDetalhePedido from '../../pedidos/ModalDetalhePedido';
import { StatusComandaItem } from "../../../models/controleBar/comandas/StatusComandaItem";
import { StatusMesa } from "../../../models/controleBar/mesas/StatusMesa";
import DeleteComandaItemModal from '../../../components/modal/controleBar/ComandaItemModal';
import { fetchData } from '../../../services/Api';
import { useConfigPedido } from '../../../contexts/pedidos/ConfigPedidoContext';
import { useConfigModulo } from '../../../contexts/administrativo/ConfigModuloContext';
import { getNumeroPedido } from '../../../utils/pedidoUtils';
import { StatusPedido, getStatusPedidoDescricao } from '../../../models/pedidos/StatusPedido';
import { salvarPedidoAvulsoGarcom, salvarPedidoGarcom } from '../../../services/pedidos/PedidoService';
import ComandaItemActions from './ComandaItemActions';

const normalizarTexto = (valor) => String(valor || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .trim()
  .toLowerCase();

const podeAgruparItemConcluido = (item) =>
  normalizarTexto(getStatusPedidoDescricao(item?.pedido?.statusPedido)) === "concluido" &&
  Number(item?.valorPago || 0) === 0;

const getChaveAgrupamentoItem = (item) => [
  item?.produtoId || item?.produto?.id || normalizarTexto(item?.produto?.descricao || item?.xProd),
  Number(item?.valorUnitario || 0).toFixed(4),
  item?.status,
].join("|");

const agruparItensConcluidos = (itens = []) => {
  const grupos = new Map();
  const itensExibicao = [];

  itens.forEach((item) => {
    if (!podeAgruparItemConcluido(item)) {
      itensExibicao.push({ ...item, itensOriginais: [item], agrupado: false });
      return;
    }

    const chave = getChaveAgrupamentoItem(item);
    const grupoExistente = grupos.get(chave);

    if (grupoExistente) {
      grupoExistente.itensOriginais.push(item);
      grupoExistente.qtde += Number(item.qtde || 0);
      grupoExistente.valorTotal += Number(item.valorTotal || 0);
      grupoExistente.valorPago += Number(item.valorPago || 0);
      grupoExistente.agrupado = true;
      return;
    }

    const novoGrupo = {
      ...item,
      itensOriginais: [item],
      agrupado: false,
      qtde: Number(item.qtde || 0),
      valorTotal: Number(item.valorTotal || 0),
      valorPago: Number(item.valorPago || 0),
    };

    grupos.set(chave, novoGrupo);
    itensExibicao.push(novoGrupo);
  });

  return itensExibicao;
};

const MesaControlePage = () => {
  const { mesaId } = useParams(); // Recupera o mesaId da URL
  const { showMessage } = useMessage();
  const { showAlert } = useAlert();
  const { showYesNo } = useYesNo();
  const { configPedido } = useConfigPedido();
  const { configModuloSel } = useConfigModulo();
  const { fetchMesaById, fetchMesaByMesaConfId, mesaSel, updateMesa, deleteMesa } = useMesa();
  const { comandasByMesa, fetchComandas, comandaSel, setComandaSel, deleteComanda } = useComanda();
  const { setComandaItens, setComandaItemSel, addItem, updateItem, deleteItem } = useComandaItem();
  const { produtos } = useProduto();
  const { showProdutoSearch } = useProduto();

  const navigate = useNavigate();

  const [showItemModal, setShowItemModal] = useState(false);
  const [showCadComanda, setShowCadComanda] = useState(false);
  const [comandaParaEditar, setComandaParaEditar] = useState(null);
  const [showJuntarModal, setShowJuntarModal] = useState(false);
  const [isModalPedidoOpen, setIsModalPedidoOpen] = useState(false);
  const [isModalDetalheOpen, setIsModalDetalheOpen] = useState(false);
  const { findPedido, setPedidoSel, getPedidoById } = usePedido();

  const [showFecharModal, setShowFecharModal] = useState(false);
  const [showFecharMesaModal, setShowFecharMesaModal] = useState(false);

  const [showImprimirModal, setShowImprimirModal] = useState(false);
  const { printResumoComandasPDF } = usePrinterComanda();

  const [showAddItemPedidoModal, setShowAddItemPedidoModal] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);

  const [showDeleteItemModal, setShowDeleteItemModal] = useState(false);
  const [motivoExclusao, setMotivoExclusao] = useState("");
  const [itemParaExcluir, setItemParaExcluir] = useState(null);
  const [acaoEmAndamento, setAcaoEmAndamento] = useState(false);
  const acaoEmAndamentoRef = useRef(false);
  const comandas = comandasByMesa || [];
  

  const location = useLocation();
  const navegacaoComandaRef = useRef({
    key: location.key,
    comandaId: location.state?.comandaId,
  });

  useEffect(() => {
    if (navegacaoComandaRef.current.key !== location.key) {
      navegacaoComandaRef.current = {
        key: location.key,
        comandaId: location.state?.comandaId,
      };
    }

    // 🔒 Blindagem
    if (!Array.isArray(comandas) || comandas.length === 0) {
      if (comandaSel) setComandaSel(null);
      return;
    }

    // 🔥 PRIORIDADE: veio da tela "Filtrar Comandas"
    if (navegacaoComandaRef.current.comandaId) {
      const comandaDaBusca = comandas.find(
        c => String(c.id) === String(navegacaoComandaRef.current.comandaId)
      );

      if (comandaDaBusca) {
        navegacaoComandaRef.current.comandaId = null;
        setComandaSel(comandaDaBusca);
        return; // ⛔ não deixa cair nas regras automáticas
      }
    }

    // 🔹 Caso 1: só existe UMA comanda e nenhuma selecionada
    if (comandas.length === 1 && !comandaSel) {
      setComandaSel(comandas[0]);
      return;
    }

    // 🔹 Caso 2: já existe comanda selecionada → re-sincroniza
    if (comandaSel) {
      const comandaAtualizada = comandas.find(
        c => c.id === comandaSel.id
      );

      // ❌ Se a comanda não existe mais
      if (!comandaAtualizada) {
        setComandaSel(null);
        return;
      }

      // ♻️ Se mudou a referência, atualiza
      if (comandaAtualizada !== comandaSel) {
        setComandaSel(comandaAtualizada);
      }
    }
  }, [comandas, comandaSel, location.key, location.state, setComandaSel]);

  const validarCaixaAbertoParaFechamento = async () => {
    try {
      const caixaSel = await fetchData('/Caixa', { caixaId: 1 });

      if (!caixaSel?.aberto) {
        showMessage(
          "Caixa fechado! Para fechar a comanda ou a mesa, é necessário abrir o caixa.",
          "warning"
        );
        return false;
      }

      return true;
    } catch (error) {
      console.error("Erro ao buscar o status do caixa:", error);
      showAlert("Erro ao buscar o status do caixa", "danger");
      return false;
    }
  };



  const abrirModalExcluirItem = (item) => {
    setItemParaExcluir(item);
    setMotivoExclusao("");
    setShowDeleteItemModal(true);
  };

  const confirmarExclusaoItem = async () => {
    try {
      await deleteItem(itemParaExcluir.id, motivoExclusao);

      setShowDeleteItemModal(false);
      setMotivoExclusao("");
      setItemParaExcluir(null);

      await fetchComandas(mesaSel.id);
      showAlert("Item excluído com sucesso!", "success");

    } catch (err) {
      console.error(err);
      showAlert("Erro ao excluir item!", "error");
    }
  };




  const getNomePedidoComanda = (comanda = comandaSel) =>
    `Mesa ${mesaSel?.codigo || '--'} - #${comanda?.codigo || '--'}`;

  const atualizarComandasAposPedidoGarcom = async (
    pedidoResult,
    comandaIdSelecionada = comandaSel?.id
  ) => {
    if (!pedidoResult?.comandaItens?.length) return;

    const comandasAtualizadas = await fetchComandas(mesaSel.id);
    const comandaAtualizada = comandasAtualizadas?.find(
      (comanda) => comanda.id === comandaIdSelecionada
    );

    if (comandaAtualizada) {
      setComandaSel(comandaAtualizada);
    }
  };

  const handleAddItem = async () => {
    const produtoSel = await showProdutoSearch();
    if (produtoSel) {
      const payloadPedido = new Pedido();
      payloadPedido.nomeCliente = getNomePedidoComanda();
      payloadPedido.comandaId = comandaSel?.id || null;

      setPedidoSel(payloadPedido);
      setProdutoSelecionado(produtoSel);
      setShowAddItemPedidoModal(true);
    }
  };


  useEffect(() => {
    if (!mesaId) return;

    const carregarMesa = async () => {
      try {
        if (mesaId.startsWith("temp-")) {
          // 🔹 Extrai o MesaConfId
          const mesaConfId = parseInt(mesaId.replace("temp-", ""), 10);

          // 🔹 Busca mesa pelo MesaConfId
          const mesaResult = await fetchMesaByMesaConfId(mesaConfId);
          fetchComandas(mesaResult.id);
          
        } else {
          // 🔹 Mesa real pelo Id          
          fetchMesaById(mesaId);
          fetchComandas(mesaId);
        }
      } catch (error) {
        console.error("Erro ao carregar mesa:", error);
      }
    };

    carregarMesa();

  }, [mesaId]);



  useEffect(() => {
    if (comandaSel) {
      setComandaItens(comandaSel.comandaItens || []);
    } else {
      setComandaItens([]);
    }
  }, [comandaSel, setComandaItens]);


  const handleSelecionaComanda = (comanda) => {
    setComandaSel(comanda);
  };

  const clonarPedidoItem = (pedidoItemOrigem) => {
    if (!pedidoItemOrigem) return null;

    const valorItem = Number(pedidoItemOrigem.valorItem || 0);
    const valorAdicional = Number(pedidoItemOrigem.valorAdicional || 0);

    return {
      ...pedidoItemOrigem,
      id: 0,
      pedidoId: 0,
      tempId: Date.now(),
      qtde: 1,
      valorTotal: valorItem + valorAdicional,
      pedidoItemAdicionais: (pedidoItemOrigem.pedidoItemAdicionais || []).map((adicional) => ({
        ...adicional,
        id: 0,
        pedidoItemId: 0,
      })),
      pedidoItemConjuntos: (pedidoItemOrigem.pedidoItemConjuntos || []).map((conjunto) => ({
        ...conjunto,
        id: 0,
        pedidoItemId: 0,
      })),
    };
  };

  const handleAddProdutoNaComanda = async (itemOrigem, comandaDestino) => {
    try {
      if (!comandaDestino?.id) {
        showMessage("Selecione uma comanda para adicionar o item.", "warning");
        return;
      }

      setComandaSel(comandaDestino);

      if (itemOrigem?.pedidoId && itemOrigem?.pedidoItemId) {
        const pedidoOrigem = await getPedidoById(itemOrigem.pedidoId);
        const pedidoItemOrigem = pedidoOrigem?.pedidoItens?.find(
          (pedidoItem) => pedidoItem.id === itemOrigem.pedidoItemId
        );

        if (!pedidoOrigem?.id || !pedidoItemOrigem) {
          showMessage("NÃ£o foi possÃ­vel localizar o item original do pedido.", "warning");
          return;
        }

        const pedidoAvulso = Boolean(pedidoOrigem.avulso);
        const pedidoItemClonado = {
          ...clonarPedidoItem(pedidoItemOrigem),
          enviarCozinha: !pedidoAvulso,
        };
        const now = new Date();
        now.setMinutes(now.getMinutes() + parseInt(configPedido?.previsaoMin || 0, 10));

        const horaPrevisao = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
        const valorItens = Number(pedidoItemClonado?.valorTotal || 0);

        const pedidoPayload = {
          ...new Pedido(),
          statusPedido: pedidoAvulso ? StatusPedido.Concluido : StatusPedido.EmProducao,
          tipoEntregaId: 3,
          formaPagId: null,
          nomeCliente: getNomePedidoComanda(comandaDestino),
          comandaId: comandaDestino.id,
          horaPrevisao,
          valorItens,
          valorTotal: valorItens,
          avulso: pedidoAvulso,
          pedidoItens: [pedidoItemClonado],
        };

        const pedidoResult = pedidoAvulso
          ? await salvarPedidoAvulsoGarcom({
              pedido: pedidoPayload,
              pedidoItem: pedidoItemClonado,
              comandaId: comandaDestino.id,
            })
          : await salvarPedidoGarcom({
              pedido: pedidoPayload,
              comandaId: comandaDestino.id,
            });

        await atualizarComandasAposPedidoGarcom(pedidoResult, comandaDestino.id);
        return;
      }

      // procura o produto pelo id ou pelo ean
      const code = itemOrigem?.produtoId;
      const product = produtos.find(
        (p) => p.id.toString() === code.toString() || p.ean === code.toString()
      );

      if (!product) {
        showMessage("Produto não encontrado!", "warning");
        return;
      }

      // pega o maior número de item atual da comanda
      const maiorItem =
        comandaDestino.comandaItens?.length > 0
          ? Math.max(...comandaDestino.comandaItens.map((i) => i.item || 0))
          : 0;

      // monta o novo comandaItem
      const novoComandaItem = {
        produtoId: product.id,
        comandaId: comandaDestino.id,
        item: maiorItem + 1,
        qtde: 1,
        valorUnitario: product.preco,
        valorTotal: product.preco * 1,
        xProd: product.descricao,
      };

      // chama o contexto para salvar
      const result = await addItem(novoComandaItem);

      // seleciona o item criado (se for necessário em outro lugar)
      setComandaItemSel(result);

      // atualiza a comandaSel no estado, garantindo que a grid renderize o novo item
      setComandaSel({
        ...comandaDestino,
        comandaItens: [...(comandaDestino.comandaItens || []), result],
      });
    } catch (err) {
      console.error("Erro ao adicionar produto na comanda:", err);
      showMessage("Erro ao adicionar produto!", "error");
    }
  };

  const handleCloseCadPedido = async (pedidoResult) => {
    setIsModalPedidoOpen(false);
    setProdutoSelecionado(null);
    await atualizarComandasAposPedidoGarcom(pedidoResult);
  };

  const handleCadNovoPedido = async () => {
    try {

      const payloadPedido = new Pedido();
      payloadPedido.nomeCliente = getNomePedidoComanda();
      payloadPedido.comandaId = comandaSel?.id || null;
      setPedidoSel(payloadPedido);
      //setSelectedPedido(new Pedido());
      setProdutoSelecionado(null);
      setIsModalPedidoOpen(true);
      
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  };

  const handleSalvarPedidoAvulso = async (pedidoItem, opcoes = {}) => {
    try {
      const now = new Date();
      now.setMinutes(now.getMinutes() + parseInt(configPedido?.previsaoMin || 0, 10));

      const horaPrevisao = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      const valorItens = Number(pedidoItem?.valorTotal || 0);
      const enviarParaCozinha = opcoes?.enviarParaCozinha !== false;
      const avulso = !enviarParaCozinha;

      const pedidoItemPayload = {
        ...pedidoItem,
        enviarCozinha: enviarParaCozinha,
      };

      const pedidoPayload = {
        ...new Pedido(),
        statusPedido: avulso ? StatusPedido.Concluido : StatusPedido.EmProducao,
        tipoEntregaId: 3,
        formaPagId: null,
        nomeCliente: getNomePedidoComanda(),
        comandaId: comandaSel?.id || null,
        horaPrevisao,
        valorItens,
        valorTotal: valorItens,
        avulso,
        pedidoItens: [pedidoItemPayload],
      };

      const pedidoResult = enviarParaCozinha
        ? await salvarPedidoGarcom({
            pedido: pedidoPayload,
            comandaId: comandaSel.id,
          })
        : await salvarPedidoAvulsoGarcom({
            pedido: pedidoPayload,
            pedidoItem: pedidoItemPayload,
            comandaId: comandaSel.id,
          });

      await atualizarComandasAposPedidoGarcom(pedidoResult);
      setShowAddItemPedidoModal(false);
      setProdutoSelecionado(null);
    } catch (error) {
      console.error('Erro ao salvar pedido avulso:', error);
      showMessage('Erro ao salvar o pedido avulso.', 'error');
    }
  };

  const handleDetalhePedido = async (pedidoId) => {
    try {
      await findPedido(pedidoId);
      setIsModalDetalheOpen(true);
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  };

  const handleCloseDetalhePedido = async () => {
    try {
      fetchComandas(mesaSel.id);
      setIsModalDetalheOpen(false);
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  }; 
  
  const comandaFechada =
    comandaSel?.comandaItens?.length > 0 &&
    comandaSel.comandaItens.every(i => i.status === StatusComandaItem.Fechado);

  const getPedidoStatusClass = (statusDescricao) => {
    const status = String(statusDescricao || "").toLowerCase();

    if (status === "cancelado") return "pedido-status-cancelado";
    if (status === "pronto" || status === "aguardando retirada/entrega") return "pedido-status-pronto";
    if (status === "concluído" || status === "concluido") return "pedido-status-concluido";
    if (status.includes("produ")) return "pedido-status-producao";
    if (status.includes("an")) return "pedido-status-analise";

    return "pedido-status-neutro";
  };

  const getComandaItemRowClass = (item) => {
    switch (item.status) {
      case StatusComandaItem.Fechado:
        return "comanda-item-pago-total-row";
      case StatusComandaItem.ParcialmentePago:
        return "comanda-item-pago-parcial-row";
      case StatusComandaItem.Cancelado:
        return "comanda-item-cancelado-row";
      default:
        return "";
    }
  };

  const getTotalComanda = (comanda) =>
    (comanda?.comandaItens || []).reduce((sum, item) => sum + Number(item.valorTotal || 0), 0);

  const comandaComValorZerado = (comanda) => getTotalComanda(comanda) <= 0;

  const todasComandasComValorZerado = (listaComandas) =>
    Array.isArray(listaComandas) && listaComandas.every(comandaComValorZerado);

  const comandaTotalmenteFechada = (comanda) =>
    comanda?.comandaItens?.length > 0 &&
    comanda.comandaItens.every(i =>
      i.status === StatusComandaItem.Fechado || i.status === StatusComandaItem.Cancelado
    );

  const todasComandasFechadas = (listaComandas) =>
    Array.isArray(listaComandas) &&
    listaComandas.length > 0 &&
    listaComandas.every(comandaTotalmenteFechada);

  const excluirComandaSelecionada = async () => {
    const resposta = await showYesNo(
      `A comanda #${comandaSel.codigo} está com valor zerado. Deseja excluir esta comanda?`
    );

    if (!resposta) return;

    try {
      await deleteComanda(comandaSel.id);
      setComandaSel(null); // limpa seleção
      const comandasAtualizadas = await fetchComandas(mesaSel.id); // atualiza lista

      if (comandasAtualizadas.length === 0) {
        await deleteMesa(mesaSel.id);
        navigate("/mesaPage");
      }
    } catch (error) {
      console.error("Erro ao excluir comanda selecionada:", error);
    }
  };

  const finalizarMesaSemValor = async () => {
    try {
      await updateMesa({
        ...mesaSel,
        status: StatusMesa.Fechada,
        fechamento: new Date().toISOString(),
        valorPago: mesaSel?.valorPago ?? mesaSel?.valorTotal ?? 0,
      });

      setComandaSel(null);
      showAlert("Mesa finalizada com sucesso!", "success");
      navigate("/mesaPage");
      return true;
    } catch (error) {
      console.error("Erro ao finalizar mesa:", error);
      showAlert("Erro ao finalizar mesa!", "danger");
      return false;
    }
  };

  const executarAcao = async (acao) => {
    if (acaoEmAndamentoRef.current) return;

    acaoEmAndamentoRef.current = true;
    setAcaoEmAndamento(true);

    try {
      await acao();
    } finally {
      acaoEmAndamentoRef.current = false;
      setAcaoEmAndamento(false);
    }
  };


  return (
    <PageContainer>
      <div className="header-mesa">
        <button className="btn-voltar" onClick={() => navigate('/mesaPage')}>
          <FaArrowLeft style={{ marginRight: 6 }} />
          Voltar
        </button>

        <h2 className="page-title">Dados da Mesa {mesaSel?.codigo || '...'}</h2>

        <button
          type="button"
          className="btn-pedidos"
          onClick={() => navigate('/pedido')}
          title="Ir para Pedidos"
        >
          Pedidos <FaClipboardList style={{ marginLeft: 6 }} />
        </button>
      </div>

      <PageHeader />

      <PageContent maxAltura="calc(100vh - 55px)">
        <div className="mesa-detalhe-grid">
          {/* Coluna 1 - Ações */}
          <div className="coluna-acoes">
            <h3>Ações</h3>
            <button
              className="btn-acao green"
              disabled={acaoEmAndamento}
              onClick={() => executarAcao(async () => {
                setComandaParaEditar(null);
                setShowCadComanda(true);
              })}
            >
              <FaPlus /> Incluir Comanda
            </button>

            <button
              className="btn-acao green"
              disabled={acaoEmAndamento}
              onClick={() => executarAcao(async () => setShowJuntarModal(true))}
            >
              <BsUnion /> Juntar Comandas
            </button>
            <button
              className="btn-acao blue"
              disabled={acaoEmAndamento}
              onClick={() => executarAcao(async () => {
                if (comandas.length === 1) {
                  // 🖨️ Imprime direto
                  printResumoComandasPDF(mesaSel, [comandas[0]]);
                } else {
                  // 📋 Abre modal para seleção
                  setShowImprimirModal(true);
                }
              })}
            >
              <FaPrint /> Imprimir Resumo
            </button>

            <button
              className="btn-acao red"
              disabled={comandaFechada || acaoEmAndamento}
              onClick={() => executarAcao(async () => {
                if (!comandaSel) {
                  showMessage("Selecione uma comanda antes de fechar!", "warning");
                  return;
                }

                // ✅ Verifica se a comanda selecionada está zerada
                if (!comandaSel.comandaItens || comandaSel.comandaItens.length === 0 || comandaComValorZerado(comandaSel)) {
                  await excluirComandaSelecionada();
                  return;
                }

                if (comandaFechada) {
                  showMessage("Esta comanda já está fechada.", "info");
                  return;
                }

                // ✅ Se tiver itens, abre o modal de fechamento normalmente
                // 🔄 Atualiza as comandas antes de abrir o modal
                if (!(await validarCaixaAbertoParaFechamento())) {
                  return;
                }

                const comandasAtualizadas = await fetchComandas(mesaSel.id);

                // 🔎 Reencontra a comanda atualizada
                const comandaAtualizada = comandasAtualizadas?.find(
                  c => c.id === comandaSel.id
                );

                // ♻️ Atualiza a seleção com dados novos
                if (comandaAtualizada) {
                  setComandaSel(comandaAtualizada);
                }

                // ✅ Agora sim abre o modal
                setShowFecharModal(true);

              })}
            >
              <FaDoorClosed /> Fechar Comanda
            </button>
            <button
              className="btn-acao red"
              disabled={acaoEmAndamento}
              onClick={() => executarAcao(async () => {
                // ✅ Verifica se NÃO tem comandas
                if (comandas.length === 0) {
                  const resposta = await showYesNo("Esta mesa não possui nenhuma comanda nem itens. Deseja excluir a mesa?");
                  if (resposta) {
                      // 👉 Aqui você chama a função que exclui a mesa (implemente se já existir)
                      // Exemplo:
                      await deleteMesa(mesaSel.id);
                      
                      //navigate("/mesaPage");
                  }
                  return;
                }

                // ✅ Verifica se todas as comandas estão zeradas
                if (todasComandasComValorZerado(comandas)) {
                  const resposta = await showYesNo("Todas as comandas da mesa estão com valor zerado. Deseja excluir a mesa?");

                  if (resposta) {
                    // 🗑️ Deletar todas as comandas existentes
                    for (const c of comandas) {
                      await deleteComanda(c.id);
                    }

                    // 🗑️ Depois deletar a mesa
                    await deleteMesa(mesaSel.id);
                    
                    //navigate("/mesaPage");
                  }
                  return;
                }

                // ✅ Se tiver itens, abre o modal normalmente
                if (!(await validarCaixaAbertoParaFechamento())) {
                  return;
                }

                if (todasComandasFechadas(comandas)) {
                  const resposta = await showYesNo("Esta mesa não possui valor em aberto. Deseja finalizar a mesa?");

                  if (resposta) {
                    await finalizarMesaSemValor();
                  }
                  return;
                }

                setShowFecharMesaModal(true);
              })}
            >
              <MdTableBar /> Fechar Mesa
            </button>

          </div>

          {/* Coluna 2 - Itens */}
          <div className="coluna-itens">
            <h3>Itens das Comandas</h3>

            {comandas.length === 0 ? (
              <p>Nenhuma comanda encontrada.</p>
            ) : (
              comandas.map((c) => {
                const selecionada = comandaSel?.id === c.id;
                const itensExibicao = agruparItensConcluidos(c.comandaItens);

                const comandaFechada =
                  c.comandaItens?.length > 0 &&
                  c.comandaItens.every(i => i.status === StatusComandaItem.Fechado);
                  

                return (
                  <div
                      key={c.id}
                      className={`comanda-itens-box ${selecionada ? 'selected' : ''}`}
                      onClick={() => {
                        if (comandaFechada) return;
                        handleSelecionaComanda(c);
                      }}
                    >

                    <h4
                      className={`
                        ${selecionada ? 'comanda-titulo-selected' : 'comanda-titulo'}
                        ${comandaFechada ? 'comanda-titulo-fechada' : ''}
                      `}
                      style={!comandaFechada ? { cursor: 'pointer' } : undefined}
                    >
                      <div className="comanda-titulo-container">
                        <span className="comanda-titulo-texto">
                          #{c.codigo}
                          {(!c.nomeCliente || c.nomeCliente === 'CONSUMIDOR FINAL')
                            ? ''
                            : ' - ' + c.nomeCliente}
                        </span>

                        {comandaFechada && (
                          <span className="comanda-status-fechada" >
                            Fechada
                          </span>
                        )}

                        {selecionada && !comandaFechada && (
                          <div className="comanda-botoes">

                            {/* 🔴 BOTÃO NOVO — Add Comanda */}
                            <button
                              className="btn-add-comanda"
                              onClick={handleAddItem}
                              style={{ marginRight: 8 }}
                            >
                              <FaTag /> Item Avulso
                            </button>


                            {/* 🟢 Botão já existente — Add Pedido */}
                            <button onClick={handleCadNovoPedido}>
                              <FaUtensils /> Pedido Cozinha
                            </button>

                            <button
                              className="btn-edit-comanda"
                              onClick={(e) => {
                                e.stopPropagation();
                                setComandaParaEditar(c);
                                setShowCadComanda(true);
                              }}
                            >
                              <FaEdit /> Editar Comanda
                            </button>

                          </div>
                        )}

                      </div>

                    </h4>

                    {/* Tabela de itens */}
                    {c.comandaItens?.length > 0 ? (
                      <>
                        <table className="mesa-tabela">
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Dados Pedido</th>
                              <th>Hora</th>                              
                              <th>Descrição</th>
                              <th>Qtde</th>                              
                              <th>Valor</th>
                              <th>Valor Pago</th>
                              <th>Status</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {itensExibicao.map((item) => {
                              let statusDescricao = getStatusPedidoDescricao(item.pedido?.statusPedido) || "";                              

                              if (statusDescricao === "Aguardando Retirada/Entrega") {
                                statusDescricao = "Pronto";
                              }

                              return (
                                <tr key={item.agrupado ? `grupo-${item.id}` : item.id} className={getComandaItemRowClass(item)}>
                                  <td style={{ textAlign: "center" }}>{item.item}</td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.pedidoId ? (
                                      <span className={`pedido-status-badge ${getPedidoStatusClass(statusDescricao)}`}>
                                        {item.agrupado
                                          ? statusDescricao
                                          : `${getNumeroPedido(item.pedido, configModuloSel)} - ${statusDescricao}`}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.dataCad
                                      ? new Date(item.dataCad).toLocaleTimeString("pt-BR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "-"}
                                  </td>

                                  <td>{item.produto?.descricao || item.xProd}</td>
                                  <td style={{ textAlign: "center" }}>{item.qtde}</td>
                                  <td style={{ textAlign: "right" }}>R$ {item.valorTotal?.toFixed(2)}</td>
                                  <td style={{ textAlign: "right" }}>R$ {item.valorPago?.toFixed(2)}</td>

                                  <td style={{ textAlign: "center" }}>
                                    {getStatusComandaItemDescricao(item.status) || "—"}
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <ComandaItemActions
                                      item={item}
                                      comanda={c}
                                      comandaFechada={comandaFechada}
                                      onAdicionar={handleAddProdutoNaComanda}
                                      onRemover={abrirModalExcluirItem}
                                      onGerenciar={handleDetalhePedido}
                                    />
                                  </td>
                                </tr>
                              );
                            })}

                          </tbody>
                        </table>

                        <p
                          style={{
                            textAlign: "right",
                            fontWeight: "bold",
                            marginTop: "0px",
                            marginBottom: "0px",
                          }}
                        >
                          Total: R${" "}
                          {getTotalComanda(c).toFixed(2)}
                        </p>
                      </>
                    ) : (
                      <>
                        <p>Nenhum item nesta comanda.</p>
                        <p
                          style={{
                            textAlign: "right",
                            fontWeight: "bold",
                            marginTop: "0px",
                            marginBottom: "0px",
                          }}
                        >
                          Total: R$ 0.00
                        </p>
                      </>
                    )}

                  </div>
                );
              })
            )}

            
          </div>
        </div>
      </PageContent>

      <ComandaItemModal
        show={showItemModal}
        onHide={() => setShowItemModal(false)}
        onConfirm={
          async (itensAtualizados) => {
          for (const item of itensAtualizados) {
            // Regra: se valorPago >= valorTotal → Fechado, senão ParcialmentePago
            const statusNovo =
              item.valorPago >= item.valorTotal
                ? 2 // Fechado
                : item.valorPago > 0
                ? 1 // ParcialmentePago
                : 0; // Aberto

            const payload = {
              ...item,
              status: statusNovo,
            };

            await updateItem(payload); // Atualiza valorPago + status
          }

          setShowFecharModal(false);
          showMessage("Comanda fechada com sucesso!", "success");
        }}
        onPrint={(comanda, valores) => {
          console.log("Imprimir resumo:", comanda, valores);

          // aqui você pode chamar a rotina da impressora
        }}
      />

      <AddItemPedidoModal
        show={showAddItemPedidoModal}
        onClose={() => {
          setShowAddItemPedidoModal(false);
          setProdutoSelecionado(null);
        }}
        onSaved={handleSalvarPedidoAvulso}
        produtoInicial={produtoSelecionado}
        mostrarEnviarParaCozinha
        defaultEnviarParaCozinha={false}
      />

      <CadPedido
        isOpen={isModalPedidoOpen}
        //novoPedido={novoPedidoAux}
        onClose={handleCloseCadPedido}
        pedidoComanda={true}
      />

      <ModalDetalhePedido
        isOpen={isModalDetalheOpen}
        onClose={handleCloseDetalhePedido}
        //pedido={selectedPedido}
        pedidoComanda={true}
      />

      <CadComanda
        open={showCadComanda}
        comandaEdicao={comandaParaEditar}
        onClose={() => {
          setShowCadComanda(false);
          setComandaParaEditar(null);
        }}
      />

      <JuntarComandasModal
        open={showJuntarModal}
        onClose={() => setShowJuntarModal(false)}
        comandas={comandas}
        onConfirm={(idsSelecionadas) => {
          // Filtra as comandas selecionadas
          const comandasSelecionadas = comandas.filter((c) =>
            idsSelecionadas.includes(c.id)
          );

          // Comanda final é a primeira selecionada
          const comandaBase = { ...comandasSelecionadas[0] };

          // Pega o maior número de item existente na comanda base
          let itemComandaBase =
            comandaBase.comandaItens.length > 0
              ? Math.max(...comandaBase.comandaItens.map((i) => i.item))
              : 0;

          // Adiciona itens das outras comandas
          comandasSelecionadas.slice(1).forEach((c) => {
            c.comandaItens.forEach((item) => {
              itemComandaBase++;
              const novoItem = {
                ...item,
                id: 0, // Novo ID para evitar conflitos
                item: itemComandaBase,
                comandaId: comandaBase.id, // Associa à comanda base
              };
              addItem(novoItem); // Adiciona ao estado global
            });
          });

          // Deleta as outras comandas
          const comandasDeletar = comandas.filter((c) => c.id !== comandaBase.id);
          comandasDeletar.forEach((element) => {
            deleteComanda(element.id);
          });

          // Fecha o modal
          setShowJuntarModal(false);
        }}
      />

      <FecharComandaModal
        open={showFecharModal}
        onClose={() => setShowFecharModal(false)}
        comanda={comandaSel}
        //onConfirm={() => setShowFecharModal(false)}
                  
        onPrint={(comanda, valores) => {
          console.log("Imprimir resumo:", comanda, valores);
          // aqui você pode chamar a rotina da impressora
          console.log("🖨️ Imprimir resumo da comanda:", comanda, valores);

          // ✅ transforma em array e chama a rotina de impressão diretamente
          const comandasSel = [comanda];
          printResumoComandasPDF(mesaSel, comandasSel);
        }}
      />

      <FecharMesaModal
        open={showFecharMesaModal}
        onClose={() => setShowFecharMesaModal(false)}
        mesa={mesaSel}
        comandas={comandas}
        onMesaFechada={finalizarMesaSemValor}
        onPrint={(mesa, valores) => {
          printResumoComandasPDF(mesa, comandas);
        }}
      />

      <ImprimirResumoModal
        open={showImprimirModal}
        onClose={() => setShowImprimirModal(false)}
        comandas={comandas}
      />

      <DeleteComandaItemModal
        visible={showDeleteItemModal}
        motivo={motivoExclusao}
        setMotivo={setMotivoExclusao}
        onCancel={() => setShowDeleteItemModal(false)}
        onConfirm={confirmarExclusaoItem}
      />



    </PageContainer>
  );
};

export default MesaControlePage;
